var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-qa": "deposit-info" } },
    [
      _vm.isCrowdfundingProject
        ? [
            _vm.isPayType
              ? _c(
                  "localize",
                  {
                    key: `${_vm.paymentAmount}_${_vm.paymentInfoBoxTypes.pay}`,
                    attrs: {
                      resource:
                        _vm.Resources.Checkout
                          .CheckoutPledgeInstantDepositDetailsInfoLabel,
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        attrs: {
                          "format-key": "0",
                          "data-qa": "payment-amount",
                        },
                      },
                      [_vm._v(_vm._s(_vm.paymentAmount))]
                    ),
                  ]
                )
              : _c(
                  "localize",
                  {
                    key: `${_vm.paymentAmount}_${_vm.paymentInfoBoxTypes.pledge}`,
                    attrs: {
                      resource:
                        _vm.Resources.Checkout
                          .CheckoutPledgeDeferredDepositDetailsInfoLabel,
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        attrs: {
                          "format-key": "0",
                          "data-qa": "payment-amount",
                        },
                      },
                      [_vm._v(_vm._s(_vm.paymentAmount))]
                    ),
                  ]
                ),
          ]
        : _c(
            "localize",
            {
              key: _vm.orderAmount,
              attrs: {
                resource:
                  _vm.Resources.Checkout.CheckoutDepositDetailsInfoLabel,
              },
            },
            [
              _c(
                "span",
                { attrs: { "format-key": "0", "data-qa": "payment-amount" } },
                [_vm._v(_vm._s(_vm.orderAmount))]
              ),
            ]
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }